import React from "react";
import { Image, View } from "react-native";
import { PnmacHtmlToNative } from "pnmac-universal-components";
function GetPayoffRequestSubmitted(_a) {
  var translations = _a.translations;
  return /*#__PURE__*/React.createElement(View, {
    style: {
      alignItems: "center",
      marginTop: 20
    }
  }, /*#__PURE__*/React.createElement(Image, {
    style: {
      width: 42,
      height: 51,
      marginBottom: 10
    },
    source: require("../../assets/Thumb-Up.png")
  }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.GetPayoffRequestSubmitted
  }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.GetPayoffRequestSubmitted2
  }), /*#__PURE__*/React.createElement(PnmacHtmlToNative, {
    value: translations === null || translations === void 0 ? void 0 : translations.GetPayoffRequestSubmitted3
  }));
}
export default GetPayoffRequestSubmitted;